import { createElement } from "react";
import { isLearnerChrome } from "./isLearnerChrome.js";
import { injectChromeStyles } from "./injectStyle.js";
import { renderFooter } from "./markup.js";
import { readChrome } from "./settings.js";
import "./css.js";

export function BsgFooter() {
  injectChromeStyles();
  if (!isLearnerChrome()) return null;
  return createElement("div", {
    className: "bsg-mfe-chrome",
    dangerouslySetInnerHTML: { __html: renderFooter(readChrome()) },
  });
}

export default BsgFooter;